(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  const testimonialSlider = new Swiper('.featured-products__slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.featured-products .swiper-button-prev',
      nextEl: '.featured-products .swiper-button-next'
    },
    pagination: {
      el: '.featured-products_pagination',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 16,
        allowTouchMove: false
      }
    }
  });

  // View label
  const labelButtons = document.querySelectorAll('.featured-products__item-link');
  labelButtons.forEach(button => {
    button.addEventListener('click', event => {
      console.log(button.parentElement.nextElementSibling)
      button.parentElement.nextElementSibling.classList.add('active');
    });
  });

  // Close label
  const closeLabelButtons = document.querySelectorAll('.featured-products__overlay-close');
  closeLabelButtons.forEach(button => {
    button.addEventListener('click', event => {
      button.parentElement.classList.remove('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Megamenu Overlay
  const menus = document.querySelectorAll('.header__mega-menu-wrapper');
  const header = document.querySelector('.outer-header-wrapper');

  menus.forEach(menuItem => {
    menuItem.addEventListener('mouseenter', event => {
      header.classList.add('megamenu-open');
    });
  
    menuItem.addEventListener('mouseleave', event => {
      header.classList.remove('megamenu-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-slider"] && !Shopify.designMode) return;
  try {
    
  const pressSlider = new Swiper('.press-slider__content', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.press-slider__pagination',
      clickable: true
    }
  });

  // Sync slider with thumbnails
  pressSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    const activeThumb = document.querySelector('.press-slider__logo.active');
    const newThumb = document.querySelector(`.press-slider__logo[data-index="${idx}"]`);
    
    activeThumb.classList.remove('active');
    newThumb.classList.add('active');
  });

  // Sync thumbnails with slider
  const thumbnails = document.querySelectorAll('.press-slider__logo');
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', event => {
      let idx = Number(event.currentTarget.dataset.index);

      pressSlider.slideToLoop(idx);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
  // Show bar after scroll
  let negativeHeight = 150;
  if (window.innerWidth < 768) {
    negativeHeight = 400;
  }

  const productSectionHeight = document.querySelector('.product').offsetHeight - negativeHeight;
  const headroom = new Headroom(document.querySelector('.product-bar'), { offset: productSectionHeight });
  headroom.init();

  // Scroll to top
  const toTopButton = document.querySelector('.product-bar__to-top');
  toTopButton.addEventListener('click', event => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  const productGridSlider = new Swiper('.product-grid__container', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.product-grid__pagination',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
     
  const reviewsSlider = new Swiper('.reviews-slider__container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    centerInsufficientSlides: false,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      prevEl: '.reviews-slider .swiper-button-prev',
      nextEl: '.reviews-slider .swiper-button-next'
    },
    pagination: {
      el: '.reviews-slider__pagination',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-slider"] && !Shopify.designMode) return;
  try {
    
  const pressSlider = new Swiper('.scent-slider__images', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.scent-slider__pagination',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    tippy('[data-tippy-content]', {
      placement: 'bottom'
    });
  });

  const tabs = document.querySelectorAll('.science__content-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      console.log( document.querySelector('.science__content-tab.active'))
      const tabName = tab.dataset.tabName;

      if (!tab.classList.contains('active')) {
        document.querySelector('.science__content-tab.active').classList.remove('active');
        tab.classList.add('active');

        document.querySelector('.science__table.active').classList.remove('active');
        document.querySelector(`.science__table[data-tab-name="${tabName}"]`).classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
     
  const testimonialSlider = new Swiper('.testimonials-slider__slider', {
    slidesPerView: 1.001,
    spaceBetween: 8,
    loop: true,
    centeredSlides: true,
    navigation: {
      prevEl: '.testimonials-slider .swiper-button-prev',
      nextEl: '.testimonials-slider .swiper-button-next'
    },
    breakpoints: {
      769: {
        spaceBetween: 16
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text"] && !Shopify.designMode) return;
  try {
    
  gsap.to('.text__bg', { 
    opacity: 0,
    ease: 'linear',
    scrollTrigger: {
      trigger: '.text-section',
      start: 'top bottom',
      end: '80%',
      scrub: true,
      onUpdate: self => console.log("progress", self.progress)
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-prop-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialSlider = new Swiper('.featured-benefits__slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.featured-benefits .swiper-button-prev',
      nextEl: '.featured-benefits .swiper-button-next'
    },
    pagination: {
      el: '.featured-benefits_pagination',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: false
      },
      1000: {
        slidesPerView: 2,
        spaceBetween: 16,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
